export const ERROR_CODES = {
  500: 'app.errorCode.500',
  402: 'app.errorCode.402',
  403: 'app.errorCode.403',
  551: 'app.errorCode.551',
  552: 'app.errorCode.552',
  553: 'app.errorCode.553',
  554: 'app.errorCode.554',
  555: 'app.errorCode.555',
  556: 'app.errorCode.556',
  557: 'app.errorCode.557',
  558: 'app.errorCode.558',
  559: 'app.errorCode.559',
  560: 'app.errorCode.560',
  563: 'app.errorCode.563',
  564: 'app.errorCode.564',
  565: 'app.errorCode.565',
  1001: 'app.errorCode.1001',
  1002: 'app.errorCode.1002',
  1003: 'app.errorCode.1003',
  1004: 'app.errorCode.1004',
  1005: 'app.errorCode.1005',
  1006: 'app.errorCode.1006',
  1007: 'app.errorCode.1007',
  1008: 'app.errorCode.1008',
  1009: 'app.errorCode.1009',
  1010: 'app.errorCode.1010',
  1011: 'app.errorCode.1011',
  1012: 'app.errorCode.1012',
  1013: 'app.errorCode.1013',
  1014: 'app.errorCode.1014',
  1037: 'app.errorCode.1037',
  2001: 'app.errorCode.2001',
  2002: 'app.errorCode.2002',
  2003: 'app.errorCode.2003',
  2004: 'app.errorCode.2004',
  2005: 'app.errorCode.2005',
  2010: 'app.errorCode.2010',
  2011: 'app.errorCode.2011.invalidIdentificationNumbers',
  2101: 'app.errorCode.2101',
  2102: 'app.errorCode.2102',
  2103: 'app.errorCode.2103',
  2104: 'app.errorCode.2104',
  2105: 'app.errorCode.2105',
  2106: 'app.errorCode.2106',
  2107: 'app.errorCode.2107',
  2108: 'app.errorCode.2108',
  2109: 'app.errorCode.2109',
  3001: 'app.errorCode.3001',
  3003: 'app.errorCode.3003',
  3004: 'app.errorCode.3004',
  3005: 'app.errorCode.3005',
  3006: 'app.errorCode.3006',
  3007: 'app.errorCode.3007',
  3008: 'app.errorCode.3008',
  3309: 'app.errorCode.3309',
  3310: 'app.errorCode.3310',
  3311: 'app.errorCode.3311',
  3312: 'app.errorCode.3312',
  3314: 'app.errorCode.3314',
  3315: 'app.errorCode.3315.cannotPushToThirdPartyApp',
  3316: 'app.errorCode.3316.currencyChangedMultipleTimes',
  3318: 'app.errorCode.3318',
  3319: 'app.errorCode.3319',
  3320: 'app.errorCode.3320',
  3321: 'app.errorCode.3321',
  3322: 'app.errorCode.3322.liveChanrgesEnabled',
  3323: 'app.errorCode.3323.cannotDeleteBlockItem',
  3324: 'app.errorCode.3324.moreThanOneTaxApplied',
  3325: 'app.errorCode.3325.taxNotMapped',
  3326: 'app.errorCode.3326.serviceItemNotMapped',
  3327: 'app.errorCode.3327.bankAcountVerificationFailed',
  3328: 'app.errorCode.3328.bankAcountExists',
  3329: 'app.errorCode.3329.noPaymentAccountConfigured',
  3330: 'app.errorCode.3330.updateMSPAdminRole',
  10001: 'app.errorCode.10001',
  10002: 'app.errorCode.10002',
  10003: 'app.errorCode.10003',
  10004: 'app.errorCode.10004',
  10005: 'app.errorCode.10005',
  10006: 'app.errorCode.10006',
  10007: 'app.errorCode.10007',
  10008: 'app.errorCode.10008',
  20001: 'app.errorCode.20001',
  20002: 'app.errorCode.20002',
  20003: 'app.errorCode.20003',
  20004: 'app.errorCode.20004',
  20005: 'app.errorCode.20005',
  20006: 'app.errorCode.20006',
  20007: 'app.errorCode.20007',
  20008: 'app.errorCode.20008',
  20009: 'app.errorCode.20009',
  20010: 'app.errorCode.20010',
  20100: 'app.errorCode.20100',
  20101: 'app.errorCode.20101',
  20102: 'app.errorCode.20102',
  10009: 'app.errorCode.10009',
  20011: 'app.errorCode.20011',
  20012: 'app.errorCode.20012',
  20013: 'app.errorCode.20013',
  20016: 'app.errorCode.20016',
  20107: 'app.errorCode.20107',
  20108: 'app.errorCode.20108',
  20104: 'app.errorCode.20104',
  20105: 'app.errorCode.20105',
  20106: 'app.errorCode.20106',
  20110: 'app.errorCode.20110',
  20211: 'app.errorCode.20211',
  20120: 'app.errorCode.20120',
  20121: 'app.errorCode.20121',
  20200: 'app.errorCode.20200',
  40003: 'app.errorCode.40003'
};
